import React from 'react';

const DokanPageSubtitle = ({ children, disableMargin = false }) => (
    <p className={`text-sm leading-5 font-thin text-secondary ${!disableMargin && 'mt-20px'}`}>
        {children}
    </p>
);

export default DokanPageSubtitle;
